import { Box } from '@mui/material'
import { Icon as Iconify } from '@iconify/react'
import Ribbon from 'components/common/Ribbon/Ribbon'
import RibbonButton from 'components/common/Ribbon/RibbonComponents/RibbonButton'

const DataBridgeRibbon = ({
  gridType,
  onToggleGridType,
  onAdd,
  onDelete,
  onEdit,
  changesMade,
  onSave,
  onDiscard,
  selectedRow,
}) => {
  const panels = []

  panels.push({
    panelName: '',
    items: [
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <RibbonButton
          height={55}
          iconSize={40}
          icon={
            <Iconify
              icon={gridType === 'SETTINGS' ? 'material-symbols:history-rounded' : 'material-symbols:settings'}
              width={20}
              color='#1976d2'
            />
          }
          label={gridType === 'SETTINGS' ? 'History' : 'Settings'}
          onClick={onToggleGridType}
        />
      </Box>,
    ],
  })

  if (gridType === 'SETTINGS') {
    let items = []
    items.push(
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <RibbonButton
          height={55}
          iconSize={40}
          icon={<Iconify icon='fluent:add-12-filled' width={20} color='green' />}
          label='Add'
          onClick={onAdd}
        />
      </Box>,
    )

    if (selectedRow) {
      items.push(
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <RibbonButton
            height={55}
            iconSize={40}
            icon={<Iconify icon='material-symbols:delete-outline' width={20} color='red' />}
            label='Delete'
            onClick={onDelete}
          />
        </Box>,
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <RibbonButton
            height={55}
            iconSize={40}
            icon={<Iconify icon='material-symbols:edit' width={20} color='#1976d2' />}
            label='Edit'
            onClick={onEdit}
          />
        </Box>,
      )
    }

    panels.push({
      panelName: '',
      items,
    })
  }

  panels.push({
    panelName: '',
    items: [
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <RibbonButton
          height={50}
          iconSize={36}
          icon={<Iconify icon='material-symbols:undo' width={20} color={!changesMade ? '#8a8a8a' : '#d32f2f'} />}
          label='Discard'
          disabled={!changesMade}
          onClick={onDiscard}
        />
        <RibbonButton
          height={50}
          iconSize={36}
          icon={<Iconify icon='material-symbols:save' width={20} color={!changesMade ? '#8a8a8a' : '#1976d2'} />}
          label='Save'
          disabled={!changesMade}
          onClick={onSave}
        />
      </Box>,
    ],
  })

  return <Ribbon barHeight={90} tabs={[{ panels }]} />
}

export default DataBridgeRibbon
